import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const container = (theme: Theme) => css`
  padding: ${size[12]} ${size[16]};
  display: flex;
  flex-direction: column;
  gap: ${size[8]};
  border: 1px solid ${theme.palette.tertiary.lowContrast};
  border-radius: ${theme.borderRadius.md};

  ${breakpoint.up('md')} {
    padding: ${size[16]} ${size[24]};
  }
`

export const headline = css`
  display: flex;
  align-items: center;
  gap: ${size[8]};
`

export const icon = css`
  fill: transparent;
`
